import type { CSSObject } from '@emotion/react'
import { Size, Color } from '@opallabs/gem'

const cardFooter: CSSObject = {
  borderBottomLeftRadius: Size.Rounding * 2,
  borderBottomRightRadius: Size.Rounding * 2,
  borderTop: `solid 1px ${Color.light.Surface.N300}`,
  padding: '8px 4px',
  backgroundColor: '#f7f8fa',

  '.kuiper-loader-wrapper': {
    backgroundColor: Color.light.Surface.N000,
    border: '1px solid #e9eaeb',
    borderRadius: 6,
    height: 24,
    position: 'relative',
  },
  '.kuiper-loader-container': {
    borderRadius: 6,
  },
  '.kuiper-contentPlaceholder': {
    borderBottomLeftRadius: Size.Rounding,
    borderBottomRightRadius: Size.Rounding,
  },
}

const footerWrapper: CSSObject = {
  position: 'relative',
}

export const styles = {
  cardFooter,
  footerWrapper,
}
